import { takeLatest, all } from "redux-saga/effects";
/* ------------- Types ------------- */
import { SettlementTypes } from "./settlements/settlement-actions";
import { PaymentScheduleTypes } from "./scheduled-payments/payments-actions";
import { BusinessTypes } from "./business/business-actions";
import { PaymentTrackTypes } from "./payment-track/payment-track.actions";
import { PayoutChannelTypes } from "./payout-channel/payoutchannel-actions";
import { SubscriptionTypes } from "./subscriptions/subscriptions-actions";
import { PlanGroupTypes } from "./plan-group/plan-group-actions";
import { PlanTypes } from "./plan/plan-actions";
import { EnterpriseTypes } from "./enterprise/enterprise-actions";
import { IndexingTypes } from "./indexing/indexing-actions";
import { CountriesTypes } from "./countries/countries-actions";
import { CustomersTypes } from "./customers/customers-actions";
import { VerificationTypes } from "./verifications/verifications-actions";
import { SystemBankTypes } from "./system-banks/system-banks-actions";
import { ProviderBankTypes } from "./provider-banks/provider-banks-actions";
import { DLRsTypes } from "./dlrs/dlrs-actions"
import { EmailTemplatesTypes } from "./email-template/email-template-actions";
import { IndustriesTypes } from "./industry/industry-actions";
import { AccountTypes } from "./account/account-action";

/* ------------- Sagas ------------- */
import { getSettlement, getAllSettlements, getSettlementCount, updateSettlement, deleteSettlement, getSettlementFilter, getOneSettlement, getProviderWallets, verifyBankAccount, disablePaystackOtp, confirmPaystackOtpDisabling, approvePendingSettlement, getPaymentSources, reversePendingSettlements } from "./settlements/settlements-saga";
import {
  getPaymentSchedule, getPaymentScheduleProjection, getPaymentScheduleRange, getPaymentScheduleSummary, getPaymentSchedules, updatePaymentSchedule,
  deletePaymentSchedule, notifyPaymentSchedule, getPaymentScheduleCount, getPaymentFilteredSchedules, getPaymentFilteredScheduleCount, markPaymentScheduleExternally,
  markPlanPaymentExternally, getAllFilteredPaymentSchedule, getExternalPaymentTotals, getPaymentExternalCsv, getPaymentExternalPdf
} from "./scheduled-payments/payments-sagas";
import {
  getBusiness, getBusinesses, getBusinessesCount, updateBusiness, deleteBusiness, cacheBusinessesList, enterpriseCustomersList,
  enterpriseCustomersListCount, searchBusinessCustomersSummary, getVerifiedBusinessesDetail, enableCardPayments, overrideCardFees, passingFeesOn, overrideMomoFees,
  verificationStartedRequest, businessVerificationRequest, invitationUptakeRequest, segmentRequest,
  associateSegmentWithBusinessCustomer, tagRequest, associateTagWithBusinessCustomer, dissociateTagFromBusinessCustomer, linkPlanWithBusinessCustomer, toggleReqsEnabled, createSignupReqs, fetchSignupReqs, deleteSignupReq, fetchSignupReqExclusions, createSignupReqExclusions, deleteSignupReqExclusion,
  reportConfigurationsRequest, createReportConfiguration, generateReportConfiguration, deleteReportConfiguration, enableCustomPSP, getBusinessesByName, getBusinessesByNameCount,
  createSegment, createTag, createTagGroup, updateTag, updateTagGroup, getTagGroups, getTagGroupsGraphed, getTags
} from "./business/business-saga";
import { getPaymentTrackRange } from "./payment-track/payment-track-saga";
import {
  getCollectedPaymentTracks, getMissedPaymentTrack, getExternalPaymentTrack, getAccountsPaymentSearch, getAccountsPaymentCSV,
  getAccountsPaymentPDF, getPaymentTracksCsv, getPaymentTracksPdf, getAccountsPaymentTotals, getTrackAttrributions, getFilteredDataTotals,
  getPlanPaymentSummary, getPlanReconciliationSummary, getExternalColleagueSummary,
  getExternalColleagueSummaryCsv, getExternalColleagueSummaryPdf,
  getPaymentTracksSummaryPdf, getPaymentTracksReconciliationPdf
} from "./payment-track/payment-track-saga";
import { getPayoutChannels } from "./payout-channel/payoutchannel-saga";
import {
  getSubscription, getAllSubscriptions, searchSubscriptions, getCountSubscriptions, dateFilterSubscriptions, subscriptionSearchCount, pauseSubscription, cancelSubscription,
  getAllSearchSubscriptionsCount, rescheduleSubscription, getAllSearchSubscriptions
} from "./subscriptions/subscriptions-saga";
import { getPlanGroupsGraphedArchived, getPlanGroupsGraphedActive, getPlanGroups, getPlan, getPlanGroupsGraphedAll, createPlanGroup, updatePlanGroup, addWatchers, removeWatchers, productWatchers, leaderBoard } from "./plan-group/plan-group-sagas";
import { createPlan, updatePlan, addWatchersToPlan, removeWatcherFromPlan, getAllWatchers } from "./plan/plan-sagas";
import { getCredential, enableRequest, generateRequest, disableRequest } from "./enterprise/enterprise-sagas";
import { indexSubscribers, indexPayments, indexSignupRequest, indexCustomers, indexPaymentSchedules, indexPlans, indexBusinessCustomers, indexActivities, indexSettlements } from "./indexing/indexing-sagas";
import {
  getCountry, getCountries, updateCountry, getIdentityDocument, getIdentityDocuments,
  getIdentityDocumentsCount, updateIdentityDocument, createIdentityDocument, disableIdentityDocument, getZones
} from "./countries/countries-sagas";
import {
  applyCustomerImport, getCustomerImportsList, getCustomerImport, getCustomers, getCustomersCount, getListOfCustomerEntries, getAudienceMembers,
  getAudienceCandidateSegments, getAudienceCandidateTags, saveAudienceCandidateMetadata, applyAudienceCandidates, getAudienceBulkInvitations, getAudienceBatches, uploadDocument,
  getBusinessCustomerRecord, linkBusinessCustomer, unlinkBusinessCustomer, getCanonicalBusinessCustomer,
  getBusinessCustomerSummary, getSecondaryBusinessCustomers, getSecondaryBusinessCustomersCount,
  createBusinessCustomer, updateBusinessCustomerSimple, createAudience, downloadSampleCsv, downloadAudienceCsv, submitCustomerEnrichment, getCustomerEnrichments, getCustomerEnrichmentStatus, getCustomerEnrichmentItems, sendBulkInvite
} from "./customers/customers-sagas";
import {
  getSystemBankList, getSystemBank, getSystemBanksCount, logoUpload, disableSystemBank, getListOfProviderBanks, getListOfProviders,
  getListOfBanksPerProvider, linkProviderToBank, unlinkProviderToBank
} from "./system-banks/system-banks-saga";
import {
  getProviderBankList, getProviderBanksCount, updatePaystackReveknewSubaccountBanks
} from "./provider-banks/provider-banks-saga";
import {
  getPendingVerificationList, getApprovedVerificationList, getRejectedVerificationList, getPendingVerificationCount,
  getApprovedVerificationCount, getRejectedVerificationCount, getVerificationList, getVerification, approveVerification, rejectVerification, getVerificationProof, getImage
} from "./verifications/verifications-saga";
import { getAllDLRs, getFilteredDlrs, getAllDLRsCount, getFilteredCountDLRs } from "./dlrs/dlrs-sagas"
import { getEmailTemplates, getFilteredName, createTemplate, updateTemplate, deleteTemplate } from "./email-template/email-template-sagas";
import { getIndustries, createIndustry, updateIndustry } from "./industry/industry-sagas";
import { getUserAccount } from "./account/account-saga";

// saga-method-import-needle

/* ------------- Connect Types To Sagas ------------- */
// import * as api from "./enterprise/enterprise-sagas";

export default function* root() {
  yield all([
    takeLatest(AccountTypes.ACCOUNT_REQUEST, getUserAccount),
    takeLatest(SettlementTypes.SETTLEMENT_REQUEST, getOneSettlement),
    takeLatest(SettlementTypes.SETTLEMENT_BUSINESS_REQUEST, getSettlement),
    takeLatest(SettlementTypes.SETTLEMENT_ALL_REQUEST, getAllSettlements),
    takeLatest(SettlementTypes.SETTLEMENT_COUNT_REQUEST, getSettlementCount),
    takeLatest(SettlementTypes.SETTLEMENT_FILTER_REQUEST, getSettlementFilter),
    takeLatest(SettlementTypes.SETTLEMENT_UPDATE_REQUEST, updateSettlement),
    takeLatest(SettlementTypes.SETTLEMENT_DELETE_REQUEST, deleteSettlement),
    takeLatest(SettlementTypes.PROVIDER_WALLET_REQUEST, getProviderWallets),
    takeLatest(SettlementTypes.VERIFY_ACCOUNT_REQUEST, verifyBankAccount),
    takeLatest(SettlementTypes.DISABLE_PAYSTACK_REQUEST, disablePaystackOtp),
    takeLatest(SettlementTypes.CONFIRM_DISABLE_REQUEST, confirmPaystackOtpDisabling),
    takeLatest(SettlementTypes.APPROVE_SETTLEMENT_REQUEST, approvePendingSettlement),
    takeLatest(SettlementTypes.PAYMENT_SOURCES_REQUEST, getPaymentSources),
    takeLatest(SettlementTypes.REVERSE_SETTLEMENT_REQUEST, reversePendingSettlements),

    takeLatest(PaymentScheduleTypes.PAYMENT_SCHEDULE_REQUEST, getPaymentSchedule),
    takeLatest(PaymentScheduleTypes.PAYMENT_SCHEDULE_ALL_REQUEST, getPaymentSchedules),
    takeLatest(PaymentScheduleTypes.PAYMENT_SCHEDULE_RANGE_REQUEST, getPaymentScheduleRange),
    takeLatest(PaymentScheduleTypes.PAYMENT_SCHEDULE_PROJECTION_REQUEST, getPaymentScheduleProjection),
    takeLatest(PaymentScheduleTypes.PAYMENT_SCHEDULE_SUMMARY_REQUEST, getPaymentScheduleSummary),
    takeLatest(PaymentScheduleTypes.PAYMENT_SCHEDULE_UPDATE_REQUEST, updatePaymentSchedule),
    takeLatest(PaymentScheduleTypes.PAYMENT_SCHEDULE_DELETE_REQUEST, deletePaymentSchedule),
    takeLatest(PaymentScheduleTypes.PAYMENT_SCHEDULE_NOTIFY_REQUEST, notifyPaymentSchedule),
    takeLatest(PaymentScheduleTypes.PAYMENT_SCHEDULE_COUNT_REQUEST, getPaymentScheduleCount),
    takeLatest(PaymentScheduleTypes.PAYMENT_SCHEDULE_FILTERED_REQUEST, getPaymentFilteredSchedules),
    takeLatest(PaymentScheduleTypes.PAYMENT_SCHEDULE_FILTERED_COUNT_REQUEST, getPaymentFilteredScheduleCount),
    takeLatest(PaymentScheduleTypes.MARK_PAYMENT_EXTERNALLY_REQUEST, markPaymentScheduleExternally),
    takeLatest(PaymentScheduleTypes.MARK_PLAN_PAYMENT_EXTERNALLY_REQUEST, markPlanPaymentExternally),
    takeLatest(PaymentScheduleTypes.PAYMENT_SCHEDULE_ALL_FILTERED_REQUEST, getAllFilteredPaymentSchedule),
    takeLatest(PaymentScheduleTypes.EXTERNAL_PAYMENT_TOTALS_REQUEST, getExternalPaymentTotals),
    takeLatest(PaymentScheduleTypes.PAYMENT_EXTERNAL_CSV_REQUEST, getPaymentExternalCsv),
    takeLatest(PaymentScheduleTypes.PAYMENT_EXTERNAL_PDF_REQUEST, getPaymentExternalPdf),

    takeLatest(BusinessTypes.BUSINESS_REQUEST, getBusiness),
    takeLatest(BusinessTypes.BUSINESSES_BY_NAME_REQUEST, getBusinessesByName),
    takeLatest(BusinessTypes.BUSINESSES_BY_NAME_COUNT_REQUEST, getBusinessesByNameCount),
    takeLatest(BusinessTypes.BUSINESSES_COUNT_REQUEST, getBusinessesCount),
    takeLatest(BusinessTypes.BUSINESS_ALL_REQUEST, getBusinesses),
    takeLatest(BusinessTypes.BUSINESS_UPDATE_REQUEST, updateBusiness),
    takeLatest(BusinessTypes.BUSINESS_DELETE_REQUEST, deleteBusiness),
    takeLatest(BusinessTypes.CACHE_BUSINESSES_REQUEST, cacheBusinessesList),
    takeLatest(BusinessTypes.ENTERPRISE_CUSTOMERS_REQUEST, enterpriseCustomersList),
    takeLatest(BusinessTypes.ENTERPRISE_CUSTOMERS_COUNT_REQUEST, enterpriseCustomersListCount),
    takeLatest(BusinessTypes.BUSINESS_CUSTOMERS_SEARCH_SUMMARY_REQUEST, searchBusinessCustomersSummary),
    takeLatest(BusinessTypes.APPROVED_BUSINESSES_DETAIL_REQUEST, getVerifiedBusinessesDetail),
    takeLatest(BusinessTypes.OVERRIDE_CARD_FEES_REQUEST, overrideCardFees),
    takeLatest(BusinessTypes.OVERRIDE_MOMO_FEES_REQUEST, overrideMomoFees),
    takeLatest(BusinessTypes.ENABLE_CARD_PAYMENTS_REQUEST, enableCardPayments),
    takeLatest(BusinessTypes.PASSING_FEES_ON_REQUEST, passingFeesOn),
    takeLatest(BusinessTypes.BUSINESS_VERIFICATION_REQUEST, businessVerificationRequest),
    takeLatest(BusinessTypes.VERIFICATION_STARTED_REQUEST, verificationStartedRequest),
    takeLatest(BusinessTypes.INVITATION_UPTAKE_REQUEST, invitationUptakeRequest),
    takeLatest(BusinessTypes.SEGMENT_REQUEST, segmentRequest),
    takeLatest(
      BusinessTypes.ASSOCIATE_SEGMENT_WITH_BUSINESS_CUSTOMER_REQUEST,
      associateSegmentWithBusinessCustomer
    ),
    takeLatest(BusinessTypes.TAG_REQUEST, tagRequest),
    takeLatest(
      BusinessTypes.ASSOCIATE_TAG_WITH_BUSINESS_CUSTOMER_REQUEST,
      associateTagWithBusinessCustomer
    ),
    takeLatest(
      BusinessTypes.DISSOCIATE_TAG_FROM_BUSINESS_CUSTOMER_REQUEST,
      dissociateTagFromBusinessCustomer
    ),
    takeLatest(
      BusinessTypes.LINK_PLAN_WITH_BUSINESS_CUSTOMER_REQUEST,
      linkPlanWithBusinessCustomer
    ),
    takeLatest(BusinessTypes.REPORT_CONFIGURATIONS_REQUEST, reportConfigurationsRequest),
    takeLatest(BusinessTypes.CREATE_REPORT_CONFIGURATION_REQUEST, createReportConfiguration),
    takeLatest(BusinessTypes.GENERATE_REPORT_CONFIGURATION_REQUEST, generateReportConfiguration),
    takeLatest(BusinessTypes.DELETE_REPORT_CONFIGURATION_REQUEST, deleteReportConfiguration),
    takeLatest(BusinessTypes.ENABLE_CUSTOM_PSP_REQUEST, enableCustomPSP),
    takeLatest(BusinessTypes.TOGGLE_REQS_ENABLED_REQUEST, toggleReqsEnabled),
    takeLatest(BusinessTypes.CREATE_SIGNUP_REQS_REQUEST, createSignupReqs),
    takeLatest(BusinessTypes.FETCH_SIGNUP_REQS_REQUEST, fetchSignupReqs),
    takeLatest(BusinessTypes.DELETE_SIGNUP_REQ_REQUEST, deleteSignupReq),
    takeLatest(BusinessTypes.FETCH_SIGNUP_REQ_EXCLUSIONS_REQUEST, fetchSignupReqExclusions),
    takeLatest(BusinessTypes.CREATE_SIGNUP_REQ_EXCLUSIONS_REQUEST, createSignupReqExclusions),
    takeLatest(BusinessTypes.DELETE_SIGNUP_REQ_EXCLUSION_REQUEST, deleteSignupReqExclusion),
    takeLatest(BusinessTypes.CREATE_SEGMENT_REQUEST, createSegment),
    takeLatest(BusinessTypes.CREATE_TAG_REQUEST, createTag),
    takeLatest(BusinessTypes.CREATE_TAG_GROUP_REQUEST, createTagGroup),
    takeLatest(BusinessTypes.UPDATE_TAG_REQUEST, updateTag),
    takeLatest(BusinessTypes.UPDATE_TAG_GROUP_REQUEST, updateTagGroup),
    takeLatest(BusinessTypes.TAG_GROUP_REQUEST, getTagGroups),
    takeLatest(BusinessTypes.TAG_GROUP_GRAPHED_REQUEST, getTagGroupsGraphed),
    takeLatest(BusinessTypes.TAGS_REQUEST, getTags),

    takeLatest(PaymentTrackTypes.PAYMENT_TRACK_RANGE_REQUEST, getPaymentTrackRange),
    takeLatest(PaymentTrackTypes.COLLECTED_PAYMENT_TRACK_REQUEST, getCollectedPaymentTracks),
    takeLatest(PaymentTrackTypes.MISSED_PAYMENT_TRACK_REQUEST, getMissedPaymentTrack),
    takeLatest(PaymentTrackTypes.EXTERNAL_PAYMENT_TRACK_REQUEST, getExternalPaymentTrack),
    takeLatest(PaymentTrackTypes.ACCOUNTS_PAYMENT_SEARCH_REQUEST, getAccountsPaymentSearch),
    takeLatest(PaymentTrackTypes.ACCOUNTS_PAYMENT_CSV_REQUEST, getAccountsPaymentCSV),
    takeLatest(PaymentTrackTypes.ACCOUNTS_PAYMENT_PDF_REQUEST, getAccountsPaymentPDF),
    takeLatest(PaymentTrackTypes.PAYMENT_TRACKS_CSV_REQUEST, getPaymentTracksCsv),
    takeLatest(PaymentTrackTypes.PAYMENT_TRACKS_PDF_REQUEST, getPaymentTracksPdf),
    takeLatest(PaymentTrackTypes.ACCOUNTS_PAYMENT_TOTALS_REQUEST, getAccountsPaymentTotals),
    takeLatest(PaymentTrackTypes.PAYMENT_ATTRIBUTIONS_REQUEST, getTrackAttrributions),
    takeLatest(PaymentTrackTypes.FILTERED_DATA_TOTALS_REQUEST, getFilteredDataTotals),
    takeLatest(PaymentTrackTypes.PLAN_PAYMENT_SUMMARY_REQUEST, getPlanPaymentSummary),
    takeLatest(PaymentTrackTypes.PLAN_RECONCILIATION_SUMMARY_REQUEST, getPlanReconciliationSummary),
    takeLatest(PaymentTrackTypes.EXTERNAL_COLLEAGUE_SUMMARY_REQUEST, getExternalColleagueSummary),
    takeLatest(PaymentTrackTypes.EXTERNAL_COLLEAGUE_SUMMARY_CSV_REQUEST, getExternalColleagueSummaryCsv),
    takeLatest(PaymentTrackTypes.EXTERNAL_COLLEAGUE_SUMMARY_PDF_REQUEST, getExternalColleagueSummaryPdf),
    takeLatest(PaymentTrackTypes.PAYMENT_TRACKS_SUMMARY_PDF_REQUEST, getPaymentTracksSummaryPdf),
    takeLatest(PaymentTrackTypes.PAYMENT_TRACKS_RECONCILIATION_PDF_REQUEST, getPaymentTracksReconciliationPdf),

    takeLatest(PayoutChannelTypes.PAYOUT_CHANNEL_BUSINESS_REQUEST, getPayoutChannels),

    takeLatest(SubscriptionTypes.SUBSCRIPTION_REQUEST, getSubscription),
    takeLatest(SubscriptionTypes.SUBSCRIPTION_ALL_REQUEST, getAllSubscriptions),
    takeLatest(SubscriptionTypes.SUBSCRIPTION_SEARCH_REQUEST, searchSubscriptions),
    takeLatest(SubscriptionTypes.SUBSCRIPTION_DATE_SEARCH_REQUEST, dateFilterSubscriptions),
    takeLatest(SubscriptionTypes.SUBSCRIPTION_COUNT_REQUEST, getCountSubscriptions),
    takeLatest(SubscriptionTypes.PAUSE_SUBSCRIPTION_REQUEST, pauseSubscription),
    takeLatest(SubscriptionTypes.CANCEL_SUBSCRIPTION_REQUEST, cancelSubscription),
    takeLatest(SubscriptionTypes.RESCHEDULE_SUBSCRIPTION_REQUEST, rescheduleSubscription),
    takeLatest(SubscriptionTypes.SUBSCRIPTION_SEARCH_ALL_REQUEST, getAllSearchSubscriptions),
    takeLatest(SubscriptionTypes.SUBSCRIPTION_SEARCH_ALL_COUNT_REQUEST, getAllSearchSubscriptionsCount),
    takeLatest(SubscriptionTypes.SUBSCRIPTION_SEARCH_COUNT_REQUEST, subscriptionSearchCount),

    takeLatest(PlanGroupTypes.PLAN_GROUP_GRAPHED_ACTIVE_REQUEST, getPlanGroupsGraphedActive),
    takeLatest(PlanGroupTypes.PLAN_GROUP_GRAPHED_ALL_REQUEST, getPlanGroupsGraphedAll),
    takeLatest(PlanGroupTypes.PLAN_GROUP_GRAPHED_ARCHIVED_REQUEST, getPlanGroupsGraphedArchived),
    takeLatest(PlanGroupTypes.PLAN_GROUPS_REQUEST, getPlanGroups),
    takeLatest(PlanGroupTypes.PLAN_REQUEST, getPlan),
    takeLatest(PlanGroupTypes.PLAN_GROUP_CREATE_REQUEST, createPlanGroup),
    takeLatest(PlanGroupTypes.PLAN_GROUP_UPDATE_REQUEST, updatePlanGroup),
    takeLatest(PlanGroupTypes.ADD_WATCHER_REQUEST, addWatchers),
    takeLatest(PlanGroupTypes.REMOVE_WATCHER_REQUEST, removeWatchers),
    takeLatest(PlanGroupTypes.GET_PRODUCT_WATCHER_REQUEST, productWatchers),
    takeLatest(PlanGroupTypes.LEADER_BOARD_REQUEST, leaderBoard),
    takeLatest(PlanTypes.PLAN_CREATE_REQUEST, createPlan),
    takeLatest(PlanTypes.PLAN_UPDATE_REQUEST, updatePlan),
    takeLatest(PlanTypes.PLAN_ADD_WATCHERS_REQUEST, addWatchersToPlan),
    takeLatest(PlanTypes.PLAN_REMOVE_WATCHER_REQUEST, removeWatcherFromPlan),
    takeLatest(PlanTypes.PLAN_ALL_WATCHERS_REQUEST, getAllWatchers),

    takeLatest(EnterpriseTypes.ENTERPRISE_REQUEST, getCredential),
    takeLatest(EnterpriseTypes.ENABLE_REQUEST, enableRequest),
    takeLatest(EnterpriseTypes.GENERATE_REQUEST, generateRequest),
    takeLatest(EnterpriseTypes.DISABLE_REQUEST, disableRequest),

    takeLatest(IndexingTypes.INDEX_SUBSCRIBERS_REQUEST, indexSubscribers),
    takeLatest(IndexingTypes.INDEX_PAYMENTS_REQUEST, indexPayments),
    takeLatest(IndexingTypes.INDEX_SIGNUP_REQUEST, indexSignupRequest),
    takeLatest(IndexingTypes.INDEX_CUSTOMERS_REQUEST, indexCustomers),
    takeLatest(IndexingTypes.INDEX_PAYMENT_SCHEDULES_REQUEST, indexPaymentSchedules),
    takeLatest(IndexingTypes.INDEX_PLANS_REQUEST, indexPlans),
    takeLatest(IndexingTypes.INDEX_BUSINESS_CUSTOMERS_REQUEST, indexBusinessCustomers),
    takeLatest(IndexingTypes.INDEX_ACTIVITIES_REQUEST, indexActivities),
    takeLatest(IndexingTypes.INDEX_SETTLEMENTS_REQUEST, indexSettlements),

    takeLatest(CountriesTypes.IDENTITY_DOCUMENT_REQUEST, getIdentityDocument),
    takeLatest(CountriesTypes.IDENTITY_DOCUMENTS_COUNT_REQUEST, getIdentityDocumentsCount),
    takeLatest(CountriesTypes.COUNTRY_REQUEST, getCountry),
    takeLatest(CountriesTypes.COUNTRIES_REQUEST, getCountries),
    takeLatest(CountriesTypes.IDENTITY_DOCUMENTS_REQUEST, getIdentityDocuments),
    takeLatest(CountriesTypes.UPDATE_DOCUMENT_REQUEST, updateIdentityDocument),
    takeLatest(CountriesTypes.CREATE_DOCUMENT_REQUEST, createIdentityDocument),
    takeLatest(CountriesTypes.DISABLE_IDENTITY_DOCUMENT_REQUEST, disableIdentityDocument),
    takeLatest(CountriesTypes.UPDATE_COUNTRY_REQUEST, updateCountry),
    takeLatest(CountriesTypes.ZONES_REQUEST, getZones),


    takeLatest(CustomersTypes.CUSTOMERS_REQUEST, getCustomers),
    takeLatest(CustomersTypes.CUSTOMERS_COUNT_REQUEST, getCustomersCount),
    takeLatest(CustomersTypes.CUSTOMER_IMPORTS_REQUEST, getCustomerImportsList),
    takeLatest(CustomersTypes.CUSTOMER_IMPORT_REQUEST, getCustomerImport),
    takeLatest(CustomersTypes.UPLOAD_REQUEST, uploadDocument),
    takeLatest(CustomersTypes.APPLY_UPLOAD, applyCustomerImport),
    takeLatest(CustomersTypes.ENTRIES_REQUEST, getListOfCustomerEntries),
    takeLatest(CustomersTypes.AUDIENCE_MEMBERS_REQUEST, getAudienceMembers),
    takeLatest(CustomersTypes.AUDIENCE_CANDIDATE_SEGMENTS_REQUEST, getAudienceCandidateSegments),
    takeLatest(CustomersTypes.AUDIENCE_CANDIDATE_TAGS_REQUEST, getAudienceCandidateTags),
    takeLatest(CustomersTypes.SAVE_AUDIENCE_CANDIDATE_METADATA_REQUEST, saveAudienceCandidateMetadata),
    takeLatest(CustomersTypes.APPLY_AUDIENCE_CANDIDATES_REQUEST, applyAudienceCandidates),
    takeLatest(CustomersTypes.AUDIENCE_BULK_INVITATIONS_REQUEST, getAudienceBulkInvitations),
    takeLatest(CustomersTypes.AUDIENCE_BATCHES_REQUEST, getAudienceBatches),
    takeLatest(CustomersTypes.DOWNLOAD_CSV_REQUEST, downloadSampleCsv),
    takeLatest(CustomersTypes.DOWNLOAD_AUDIENCE_CSV_REQUEST, downloadAudienceCsv),
    takeLatest(CustomersTypes.SUBMIT_CUSTOMER_ENRICHMENT_REQUEST, submitCustomerEnrichment),
    takeLatest(CustomersTypes.CUSTOMER_ENRICHMENTS_REQUEST, getCustomerEnrichments),
    takeLatest(CustomersTypes.CUSTOMER_ENRICHMENT_STATUS_REQUEST, getCustomerEnrichmentStatus),
    takeLatest(CustomersTypes.CUSTOMER_ENRICHMENT_ITEMS_REQUEST, getCustomerEnrichmentItems),
    takeLatest(CustomersTypes.BULK_PLAN_INVITE_REQUEST, sendBulkInvite),
    takeLatest(CustomersTypes.BUSINESS_CUSTOMER_RECORD_REQUEST, getBusinessCustomerRecord),
    takeLatest(CustomersTypes.LINK_BUSINESS_CUSTOMER_REQUEST, linkBusinessCustomer),
    takeLatest(CustomersTypes.UNLINK_BUSINESS_CUSTOMER_REQUEST, unlinkBusinessCustomer),
    takeLatest(CustomersTypes.CANONICAL_BUSINESS_CUSTOMER_REQUEST, getCanonicalBusinessCustomer),
    takeLatest(CustomersTypes.BUSINESS_CUSTOMER_SUMMARY_REQUEST, getBusinessCustomerSummary),
    takeLatest(CustomersTypes.SECONDARY_BUSINESS_CUSTOMERS_REQUEST, getSecondaryBusinessCustomers),
    takeLatest(CustomersTypes.SECONDARY_BUSINESS_CUSTOMERS_COUNT_REQUEST, getSecondaryBusinessCustomersCount),
    takeLatest(CustomersTypes.CREATE_BUSINESS_CUSTOMER_REQUEST, createBusinessCustomer),
    takeLatest(CustomersTypes.UPDATE_BUSINESS_CUSTOMER_SIMPLE_REQUEST, updateBusinessCustomerSimple),
    takeLatest(CustomersTypes.CREATE_AUDIENCE_REQUEST, createAudience),

    takeLatest(VerificationTypes.PENDING_VERIFICATION_LIST_REQUEST, getPendingVerificationList),
    takeLatest(VerificationTypes.APPROVED_VERIFICATION_LIST_REQUEST, getApprovedVerificationList),
    takeLatest(VerificationTypes.REJECTED_VERIFICATION_LIST_REQUEST, getRejectedVerificationList),
    takeLatest(VerificationTypes.PENDING_VERIFICATION_COUNT, getPendingVerificationCount),
    takeLatest(VerificationTypes.APPROVED_VERIFICATION_COUNT, getApprovedVerificationCount),
    takeLatest(VerificationTypes.REJECTED_VERIFICATION_COUNT, getRejectedVerificationCount),

    takeLatest(SystemBankTypes.SYSTEM_BANK_LIST_REQUEST, getSystemBankList),
    takeLatest(SystemBankTypes.SYSTEM_BANK_REQUEST, getSystemBank),
    takeLatest(SystemBankTypes.SYSTEM_BANKS_COUNT_REQUEST, getSystemBanksCount),
    takeLatest(SystemBankTypes.LOGO_REQUEST, logoUpload),
    takeLatest(SystemBankTypes.DISABLE_SYSTEM_BANK_REQUEST, disableSystemBank),
    takeLatest(SystemBankTypes.PROVIDER_BANKS_REQUEST, getListOfProviderBanks),
    takeLatest(SystemBankTypes.PROVIDERS_REQUEST, getListOfProviders),
    takeLatest(SystemBankTypes.BANK_PER_PROVIDER_REQUEST, getListOfBanksPerProvider),
    takeLatest(SystemBankTypes.LINK_REQUEST, linkProviderToBank),
    takeLatest(SystemBankTypes.UNLINK_REQUEST, unlinkProviderToBank),

    takeLatest(ProviderBankTypes.PROVIDER_BANK_LIST_REQUEST, getProviderBankList),
    takeLatest(ProviderBankTypes.PROVIDER_BANKS_COUNT_REQUEST, getProviderBanksCount),
    takeLatest(
      ProviderBankTypes.PAYSTACK_REVEKNEW_BANK_UPDATE_REQUEST,
      updatePaystackReveknewSubaccountBanks
    ),

    takeLatest(VerificationTypes.VERIFICATION_LIST_REQUEST, getVerificationList),
    takeLatest(VerificationTypes.VERIFICATION_REQUEST, getVerification),
    takeLatest(VerificationTypes.VERIFICATION_APPROVE_REQUEST, approveVerification),
    takeLatest(VerificationTypes.VERIFICATION_REJECT_REQUEST, rejectVerification),
    takeLatest(VerificationTypes.PROOF_REQUEST, getVerificationProof),
    takeLatest(VerificationTypes.IMAGE_REQUEST, getImage),

    takeLatest(DLRsTypes.FILTERED_DLRS_REQUEST, getFilteredDlrs),
    takeLatest(DLRsTypes.DLRS_ALL_REQUEST, getAllDLRs),
    takeLatest(DLRsTypes.ALL_DLRS_COUNT_REQUEST, getAllDLRsCount),
    takeLatest(DLRsTypes.FILTERED_COUNT_DLRS_REQUEST, getFilteredCountDLRs),

    takeLatest(EmailTemplatesTypes.EMAIL_TEMPLATE_REQUEST, getEmailTemplates),
    takeLatest(EmailTemplatesTypes.CREATE_EMAIL_TEMPLATE_REQUEST, createTemplate),
    takeLatest(EmailTemplatesTypes.UPDATE_EMAIL_TEMPLATE_REQUEST, updateTemplate),
    takeLatest(EmailTemplatesTypes.DELETE_EMAIL_TEMPLATE_REQUEST, deleteTemplate),
    takeLatest(EmailTemplatesTypes.FILTERED_REQUEST, getFilteredName),

    takeLatest(IndustriesTypes.INDUSTRIES_REQUEST, getIndustries),
    takeLatest(IndustriesTypes.CREATE_INDUSTRY_REQUEST, createIndustry),
    takeLatest(IndustriesTypes.UPDATE_INDUSTRY_REQUEST, updateIndustry),
  ]);
}